import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const DropdownItem = props => {
  const classes = classNames({
    'up-dropdown-item': true,
    terse: !props.icon || !props.name
  });

  return (
    <div className={classes} onClick={props.action}>
      <div className="up-item-icon">{props.icon}</div>
      <div className="up-item-name">{props.name}</div>
    </div>
  );
};

export default DropdownItem;
